export default __webpack_public_path__ + "static/media/Quicksand-Medium.f0df5c4d.woff2";